const levelsOfCare = [
  '',
  'Independent Living',
  'Assisted Living',
  'Memory Care',
  'Skilled Nursing',
  'Adult Day Care',
  'Group Home',
  'Home Health',
  'Respite',
  'Hospice',
  'Other',
]

module.exports = levelsOfCare
